import { Loader } from '@googlemaps/js-api-loader';

export const MAPS_LOADER = new Loader({
  apiKey: 'AIzaSyBX8p_iylflKjQB88-uMt2XBcDdhhKRfIw',
});
